import en from './en';
import zh from './zh';
export default {
    en: en,
    zh: zh
}


// WEBPACK FOOTER //
// ./src/i18n/langs/index.js